export default {
  path: '/redirect-to-user-front-home',
  name: `redirect-to-user-front-home`,
  component: () => import(`./index.vue`),
  meta: {
    skip_check_token: true,
  },
};
